module.exports = __webpack_public_path__ + "media/images/primary_instructor-b8755772f18fbb28a0a9b4c74f7b6ba2.png";